module.exports = __webpack_public_path__ + "static/img/S06.f43212e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/S06.png
// module id = gUs2
// module chunks = 7